import React from "react";
import {
  MpaSliderHorizontal,
  MpaSliderVertical
} from "../mpa-material-ui-widgets/mpa-material-ui-slider";
import {
  labelableSelectedStyle,
  labelableUnselectedStyle
} from "../../style-helper";

export class MpaSlider extends React.Component {
  constructor(props) {
    super(props);
    const { color, label, context, value, min, max } = props.meta.stack;
    this.state = {
      color,
      label,
      context,
      style: labelableUnselectedStyle(color),
      value,
      min,
      max
    };
  }

  componentWillUnmount() {
    const { socket } = this.props;
    socket.off("rx");
  }

  /* When the component mounts, register a handler on the "rx" topic. */
  componentDidMount() {
    const { socket, meta } = this.props;
    socket.on(`rx`, data => {
      if (data.name === meta.stack.name || data.stack === meta.stack.name) {
        switch (data.type) {
          case "TOUCH":
            let style;
            if (data.val) {
              style = labelableSelectedStyle(this.state.color);
            } else {
              style = labelableUnselectedStyle(this.state.color);
            }
            this.setState({ style });
            break;
          case "VALUE":
            if (data.val !== undefined && typeof data.val === "number") {
              this.setState({ value: data.val });
            }
            break;
          case "COLOR":
            this.setState({ color: data.val }, () =>
              this.setState({
                style: labelableUnselectedStyle(this.state.color)
              })
            );
            break;
          case "CONTEXT":
            if (data.val !== undefined && typeof data.val === "string") {
              this.setState({ context: data.val });
            }
            break;
          case "LABEL":
            if (data.val !== undefined && typeof data.val === "string") {
              this.setState({ label: data.val });
            }
            break;
          case "TYPECHANGE":
            if (data.val.type === "NUMBER") {
              this.setState({ min: data.val.min, max: data.val.max });
            }
            break;
          default:
            break;
        }
      }
    });
  }

  handleChangeVertical = (e, value) => {
    if (this.state.value === value) return;
    this.setState({ value }, () => {
      const { meta, socket } = this.props;
      socket.emit("tx", {
        widget: {
          name: meta.widget.name,
          type: "SLIDER_VERTICAL",
          event: "CHANGE_ABSOLUTE",
          value
        }
      });
    });
  };

  handleChangeHorizontal = (e, value) => {
    if (this.state.value === value) return;
    this.setState({ value }, () => {
      const { meta, socket } = this.props;
      socket.emit("tx", {
        widget: {
          name: meta.widget.name,
          type: "SLIDER_HORIZONTAL",
          event: "CHANGE_ABSOLUTE",
          value
        }
      });
    });
  };

  render() {
    const { meta, orientation } = this.props;
    return (
      <div className="labelable" style={this.state.style}>
        <div className="label widget-label">
          <label>{this.state.label}</label>
        </div>
        <div className="label context-label">
          <label>{this.state.context}</label>
        </div>
        <div className="other-widget">
          <span className="slider-value-label">{this.state.value}</span>
          {orientation === "VERTICAL" ? (
            <MpaSliderVertical
              onChange={this.handleChangeVertical}
              defaultValue={this.state.value}
              key={meta.widget.name}
              orientation={"vertical"}
              min={this.state.min}
              max={this.state.max}
              value={this.state.value}
              assignedcolor={this.state.color}
              valueLabelDisplay="off"
            ></MpaSliderVertical>
          ) : (
            <MpaSliderHorizontal
              onChange={this.handleChangeHorizontal}
              defaultValue={this.state.value}
              key={meta.widget.name}
              orientation={"horizontal"}
              min={this.state.min}
              max={this.state.max}
              value={this.state.value}
              assignedcolor={this.state.color}
              valueLabelDisplay="off"
            ></MpaSliderHorizontal>
          )}
        </div>
      </div>
    );
  }
}
